import { VirtualScrollWrapper } from '@shared/components/VirtualScroll';
import { breakpoints } from '@shared/utils/style/breakpoints';
import { styled } from '@withjoy/joykit';

export const ScrollWrapper = styled(VirtualScrollWrapper)<{ desktopHeight: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  flex: 1;
  height: 100%;
  height: 100vh;
  height: 100dvh;
  @media (min-width: ${breakpoints.md}) {
    height: ${({ desktopHeight }) => `calc(${desktopHeight} - 160px)`};
  }
`;
